import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { useIsAdmin } from 'src/session/useSession'
import AdvancedThemeProvider from '../AdvancedThemeProvider'
import AdvancedAdminPanel from './AdvancedAdminPanel'
import AdvancedHome from './AdvancedHome'
import AdvancedShell from './AdvancedShell'

const AdvancedRoutes = ({ children }: { children?: React.ReactNode }) => {
  const isAdmin = useIsAdmin()

  return (
    <AdvancedShell>
      <Route exact path="/" render={() => <Redirect to="/advanced" />} />
      <Route path="/user/:uid" render={({ match }) => <Redirect to={`/advanced/${match.params.uid}`} />} />
      <Route path="/participant/:uid/" render={({ match }) => <Redirect to={`/advanced/${match.params.uid}`} />} />
      <Route exact path="/participant" render={() => <Redirect to="/advanced" />} />
      <Route component={AdvancedHome} path="/advanced/:uid?" />
      <Route
        exact
        path="/advanced-config"
        render={() =>
          isAdmin ? (
            <AdvancedThemeProvider>
              <AdvancedAdminPanel />
            </AdvancedThemeProvider>
          ) : (
            <Redirect to="/advanced" />
          )
        }
      />
      {children}
    </AdvancedShell>
  )
}

export default AdvancedRoutes
